import { tz } from "@date-fns/tz";
import { addDays, startOfDay } from "date-fns";

import { utcDateFromLocalFields } from "@/modules/shared/components/AppDatePicker/utils/utcDateFromLocalFields";

import { MAX_AVAILABILITY_START_OFFSET_DAYS } from "../conts/sessionConsts";

const UTC_DATE_CONTEXT = { in: tz("UTC") };

// First of the last month a start_date is still accepted; UTC to match the interval helper.
export const getLastBookableMonth = (now = new Date()): Date => {
  const lastBookableDay = addDays(
    startOfDay(now, UTC_DATE_CONTEXT),
    MAX_AVAILABILITY_START_OFFSET_DAYS,
  );

  return utcDateFromLocalFields(
    lastBookableDay.getFullYear(),
    lastBookableDay.getMonth(),
    1,
  );
};
